import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

import { User } from '../../../lib/who-am-i/lib/user';

// Use git SHA for version to match Datadog source map uploads
// Falls back to 'local' for development builds without a commit SHA
const version = import.meta.env.REACT_APP_GIT_SHA || 'local';

interface TelemetryParams {
	applicationId: string;
	clientToken: string;
	service: string;
	env: string;
	user?: User;
}

export const useInitTelemetry = ({ applicationId, clientToken, service, env, user }: TelemetryParams) => {
	useEffect(() => {
		if (['production', 'staging'].includes(env)) {
			datadogRum.init({
				applicationId: applicationId,
				clientToken: clientToken,
				site: 'datadoghq.com',
				service: service,
				env: env,
				version: version,
				sessionSampleRate: 100,
				sessionReplaySampleRate: 20,
				trackUserInteractions: true,
				trackResources: true,
				trackLongTasks: true,
				defaultPrivacyLevel: 'mask-user-input',
			});

			datadogLogs.init({
				clientToken: clientToken,
				site: 'datadoghq.com',
				service: service,
				env: env,
				version: version,
				forwardErrorsToLogs: true,
				sessionSampleRate: 100,
			});
		}
	}, [applicationId, clientToken, service, env]);

	// Set user context when user data is available
	useEffect(() => {
		if (user) {
			const userContext = {
				id: user.id,
				email: user.email,
			};

			// Set user context for RUM
			if (window.DD_RUM) {
				window.DD_RUM.setUser(userContext);
			}

			// Set user context for Logs
			datadogLogs.setUserProperty('id', user.id);
			datadogLogs.setUserProperty('email', user.email);
		}
	}, [user]);
};
